export default __webpack_public_path__ + "static/cafe_instrument-749efa61e50b18917b25d06d0784a5db.png";